import ContactForm from '@/features/contactForm/ContactForm';
import { PageLayout } from '@/layout/PageLayout';
import SupportTitle from './SupportTitle';
import SupportSubtitle from './SupportSubtitle';

export default function SupportLayout() {
  return (
    <PageLayout title="Contact us" shouldAvoidIndexing>
      <div className="text-center text-white p-6 md:p-10">
        <SupportTitle />
        <SupportSubtitle />
        <ContactForm />
      </div>
    </PageLayout>
  );
}
